import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { CBadge } from '@coreui/react'
import { switchSidebarShow } from 'src/REDUX/orderSlice'

export const AppSidebarNav = ({ items, sidebarShow }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  // console.log('items', items)
  const navLink = (name, icon, badge) => {
    // console.log('name', name, 'icon', icon, 'badge', badge)

    return (
      <>

        {icon && <img src={process.env.REACT_APP_SERVER_URL + icon} alt="icon" width={20} height={20} />}
        {(name && sidebarShow) && name}
        {(badge && sidebarShow) && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}

      </>
    )
  }

  const isAnyChildActive = (items) => {
    return items?.some((child) => {
      if (child.to && location.pathname.startsWith(child.to)) return true
      if (child.items) return isAnyChildActive(child.items)
      return false
    })
  }

  const navItem = (item, index) => {
    const { component: Component, name, badge, icon, ...rest } = item;
    // console.log('item', item)
    return (
      <Component

        key={index}
        {...(rest.to && !rest.items && { component: NavLink })}
        {...rest}
      >
        {navLink(name, icon, badge)}
      </Component>
    );
  };

  const navGroup = (item, index) => {
    const { component: Component, name, icon, to, items, ...rest } = item;
    // console.log('to', to)
    // console.log('location.pathname.startsWith(to)', location.pathname.startsWith(to))


    const isGroupActive = to
      ? location.pathname.startsWith(to)
      : isAnyChildActive(items)


    const isActive =
      // !sidebarShow &&
      isGroupActive;
    return (
      <Component
        onClick={() => {
          if (!sidebarShow) {

            dispatch(switchSidebarShow(true))

          }
        }}
        idx={String(index)}
        key={index}
        toggler={navLink(name, icon)}
        // className={location.pathname.startsWith(to) ? 'parent-active' : ''}
        className={isActive ? 'parent-active' : ''}
        // visible={location.pathname.startsWith(to)}
        visible={isActive}
        {...rest}
      >
        {items?.map((subItem, subIndex) =>
          subItem.items ? navGroup(subItem, subIndex) : navItem(subItem, subIndex)
        )}
      </Component>
    );
  };

  return (
    <React.Fragment>
      {items &&
        items.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}
    </React.Fragment>
  )
}

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
}
